import React from "react";

interface CmsPreviewShellProps {
  title?: string;
  children: React.ReactNode;
}

const CmsPreviewShell: React.FC<CmsPreviewShellProps> = ({ title, children }) => (
  <div className="cms-preview">
    {title && <h4 className="cms-preview__title">{title}</h4>}
    <div className="cms-preview__body">{children}</div>
  </div>
);

export default CmsPreviewShell;
